module.exports = __webpack_public_path__ + "img/inference2.65d1a979.svg";